
import { defineComponent, computed } from "vue";
import filiation from "@/filiation/composables/useFiliation";
export default defineComponent({
  name: "Confirmation",
  components: {},
  setup() {
    const { dataToEdit } = filiation();
    const dataEdit = computed(() => dataToEdit.value);
    return {
      dataEdit,
    };
  },
});
